// extracted by mini-css-extract-plugin
module.exports = {"root":"tabs-trigger_root__I5wok"};